import { useTheme } from "@mui/material";
import { Box } from "@/Components/v2/atoms/Box";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Divider } from "@/Components/v2/atoms/Divider";
import { Skeleton } from "@/Components/v2/atoms/Skeleton";

const ActionPlanLoadingState = () => {
  const theme = useTheme();
  return (
    <Box sx={{ paddingX: 4, paddingBottom: 4, paddingTop: 3 }}>
      <Stack spacing={3}>
        {/* Breadcrumbs and buttons skeleton */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width={300} height={40} />
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" width={150} height={40} />
            <Skeleton variant="rounded" width={150} height={40} />
          </Stack>
        </Stack>

        <Divider sx={{ marginBottom: "1.5rem" }} />

        {/* MetaField skeleton */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" width={200} height={32} />
            <Skeleton variant="rounded" width={150} height={32} />
            <Skeleton variant="rounded" width={180} height={32} />
          </Stack>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" width={150} height={32} />
            <Skeleton variant="rounded" width={100} height={32} />
          </Stack>
        </Stack>

        {/* Status Banner skeleton */}
        <Skeleton variant="rounded" width="100%" height={80} />

        {/* Progress Cards skeleton */}
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rounded" sx={{ flex: 1 }} height={120} />
          <Skeleton variant="rounded" sx={{ flex: 1 }} height={120} />
          <Skeleton variant="rounded" sx={{ flex: 1 }} height={120} />
        </Stack>

        {/* Chart Container skeleton */}
        <Stack
          direction="row"
          border={`1px solid ${theme.palette.divider}`}
          borderRadius={4}
          sx={{ width: "100%", overflow: "hidden" }}
        >
          {/* Revenue Metric Cards skeleton */}
          <Box
            sx={{
              width: 280,
              borderRight: `1px solid ${theme.palette.divider}`,
              p: 2,
            }}
          >
            <Stack spacing={2}>
              <Skeleton variant="text" width="80%" height={24} />
              <Skeleton variant="rectangular" width="100%" height={80} />
              <Skeleton variant="rectangular" width="100%" height={80} />
            </Stack>
          </Box>

          {/* Chart Area skeleton */}
          <Box flexGrow={1} pt={3} pb={2} pl={2}>
            <Stack spacing={2} pr={2}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Skeleton variant="text" width={200} height={32} sx={{ ml: 2 }} />
                <Stack direction="row" spacing={1}>
                  <Skeleton variant="rounded" width={120} height={36} />
                  <Skeleton variant="rounded" width={180} height={36} />
                </Stack>
              </Stack>
              <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 2 }} />
            </Stack>
          </Box>
        </Stack>

        {/* Recommendations Section skeleton */}
        <Stack spacing={2}>
          <Skeleton variant="text" width={200} height={32} />
          <Stack direction="row" spacing={2}>
            {[1, 2, 3].map((index) => (
              <Box
                key={index}
                sx={{
                  flex: 1,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 4,
                  p: 3,
                }}
              >
                <Stack spacing={2}>
                  <Skeleton variant="rounded" width={150} height={36} />
                  <Skeleton variant="text" width="90%" height={20} />
                  <Skeleton variant="text" width="80%" height={20} />
                  <Skeleton variant="text" width="85%" height={20} />
                  <Divider />
                  <Stack spacing={1}>
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="100%" height={20} />
                  </Stack>
                  <Divider />
                  <Skeleton variant="rounded" width="100%" height={40} />
                  <Skeleton variant="rounded" width="100%" height={40} />
                </Stack>
              </Box>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ActionPlanLoadingState;
